<template lang="html">
  <section id="vehiculo-electrico" class="vehiculo-electrico">
    <intro></intro>
    <section class="carasteristicas-vehiculo">
      <div
        class="item"
        :active="carasteristicaActiva == 'catalogo'"
        @click="carasteristicaActiva = 'catalogo'"
      >
        <img
          src="/static/img/vehiculo-electrico/icon-catalogo.svg"
          alt=""
          title="icon" width="60" height="53" loading="lazy" />
        <h2 class="title">{{ $t(`vehiculo_electrico['catalogo'].titulo`) }}</h2>
        <span>+</span>
      </div>
      <div
        class="item"
        :active="carasteristicaActiva == 'sellado'"
        @click="carasteristicaActiva = 'sellado'"
      >
        <img
          src="/static/img/vehiculo-electrico/icon-sellado.svg"
          alt=""
          title="icon" width="72" height="53" loading="lazy" />
        <h2 class=" title">{{ $t(`vehiculo_electrico['sellado'].titulo`) }}</h2>
        <span>+</span>
      </div>
      <div
        class="item"
        :active="carasteristicaActiva == 'material'"
        @click="carasteristicaActiva = 'material'"
      >
        <img
          src="/static/img/vehiculo-electrico/icon-material.svg"
          alt=""
          title="icon" width="55" height="55" loading="lazy" />
        <h2 class=" title">
          {{ $t(`vehiculo_electrico['material'].titulo`) }}
        </h2>
        <span>+</span>
      </div>
    </section>
    <section class="carasteristica-descripcion">
      <div class="container">
        <p
          v-html="
            $t(`vehiculo_electrico['${carasteristicaActiva}'].descripcion`)
          "
        ></p>
      </div>
    </section>
    <section class="container-videos-vehiculo pb-0">
      <div class="container">
        <h2 class="title-36 text-center">
          {{ $t(`vehiculo_electrico['catalogo_vehiculo_hibrido']`) }}
        </h2>
        <div class="contenedor" v-if="$t(`vehiculo_electrico['videos']`)">
          <!-- <video-el
            v-if="key == 'video0'"
            v-for="(video, key) in $t(`vehiculo_electrico['videos']`)"
            :data="video"
            :idkey="key"
            @show="sendToShow"
          ></video-el> -->
          <vue-slick-carousel
            class="contenedorsliderVideos"
            ref="slick1"
            v-bind="slickOptionsVideo"
            v-if="$t(`vehiculo_electrico['videos']`)"
          >
            <video-el
              :class="key == 'video0' ? 'padding-top-intro' : ''"
              v-for="(video, key) in $t(`vehiculo_electrico['videos']`)"
              :key="key"
              :data="video"
              :idkey="key"
              @show="sendToShow"
            ></video-el>
          </vue-slick-carousel>
        </div>
        <p class="title-26 text-center mb-0">{{ $t(`vehiculo_electrico['catalogo_vehiculo_hibrido_kits']`) }}</p>
      </div>
    </section>
    <section class="container-videos-vehiculo">
      <div class="container">
        <h2 class="title-36 text-center ">
          {{ $t(`vehiculo_electrico['catalogo_juntas_compresor']`) }}
        </h2>
        <div
          class="contenedor"
          v-if="$t(`vehiculo_electrico['videosComprensor']`)"
        >
          <!-- <video-el
            v-if="key == 'video0'"
            v-for="(video, key) in $t(`vehiculo_electrico['videos']`)"
            :data="video"
            :idkey="key"
            @show="sendToShow"
          ></video-el> -->

          <vue-slick-carousel
            class="contenedorsliderVideos comprensor"
            ref="slick2"
            v-bind="slickOptionsVideo"
            v-if="$t(`vehiculo_electrico['videosComprensor']`)"
          >
            <video-el
              :class="key == 'video0' ? 'padding-top-intro' : ''"
              v-for="(video, key) in $t(
                `vehiculo_electrico['videosComprensor']`
              )"
              :key="key"
              :data="video"
              :idkey="key"
              @show="sendToShow"
            ></video-el>
          </vue-slick-carousel>
        </div>
        <div class="container text-center">
          <router-link :to="$t('enlaces.contacto')" class="btn btn-dark -pink-full">  
            {{ $t(`vehiculo_electrico.commercialInfo`) }}
          </router-link>
        </div>
      </div>
    </section>
    <video-visualizer
      :show="show_video"
      :id="video_to_show"
      @closeVideo="closeVideo"
    ></video-visualizer>
    <section class="section-experto">
      <div class="container">
        <div class="grid-img-text">
          <h2 class="title-36">{{ $t(`vehiculo_electrico.hazte_experto`) }}</h2>
          <h3 class="title-26">
            {{ $t(`vehiculo_electrico.reparacion_vehiculos`) }}
          </h3>
          <p
            v-html="$t(`vehiculo_electrico.reparacion_vehiculos_descripcion`)"
          ></p>
          <p
            v-html="$t(`vehiculo_electrico.reparacion_vehiculos_descripcion_2`)"
          ></p>
          <div class="div-btn">
            <a href="https://www.youtube.com/watch?v=svouPU4u8jY&list=PLRRSVDrXZEv4rQ042EGukArJO_XBqRONf" target="_blank" class="go">
              {{ $t(`vehiculo_electrico.accessVideoTut`) }}
              <i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
      <img
        src="/static/img/vehiculo-electrico/img-scan.png"
        :alt="$t('vehiculo_electrico.alt_images.tag_ajusa')"
        :title="$t('vehiculo_electrico.alt_images.tag_ajusa')"
        class="waypoints"
        data="fadeInUp" width="1920" height="1344" loading="lazy" />
    </section>
    <section class="carasteristicas-vehiculo -full">
      <div
        class="item"
        :active="carasteristicaActivaFull == 'porqueElegir' && isOpen"
        @click="toogleOption('porqueElegir')"
      >
        <img
          src="/static/img/vehiculo-electrico/icon-catalogo.svg"
          alt=""
          title="icono" width="60" height="53" loading="lazy" />
        <h2 class="title">
          {{ $t(`vehiculo_electrico['porqueElegir'].titulo`) }}
        </h2>
        <span>+</span>
      </div>
    </section>
    <section
      class="carasteristica-descripcion -full"
      v-if="carasteristicaActivaFull == 'porqueElegir' && isOpen"
    >
      <div class="container">
        <p
          v-html="
            $t(`vehiculo_electrico['${carasteristicaActivaFull}'].descripcion`)
          "
        ></p>
      </div>
    </section>
    <section class="carasteristicas-vehiculo -four">
      <div
        class="item"
        :active="carasteristicaActivaSecondBanner == 'medioAmbiente'"
        @click="carasteristicaActivaSecondBanner = 'medioAmbiente'"
      >
        <h2 class="title">
          {{ $t(`vehiculo_electrico['medioAmbiente'].titulo`) }}
        </h2>
        <span>+</span>
      </div>
      <div
        class="item"
        :active="carasteristicaActivaSecondBanner == 'ahorro'"
        @click="carasteristicaActivaSecondBanner = 'ahorro'"
      >
        <h2 class=" title">{{ $t(`vehiculo_electrico['ahorro'].titulo`) }}</h2>
        <span>+</span>
      </div>
      <div
        class="item"
        :active="carasteristicaActivaSecondBanner == 'experiencia'"
        @click="carasteristicaActivaSecondBanner = 'experiencia'"
      >
        <h2 class=" title">
          {{ $t(`vehiculo_electrico['experiencia'].titulo`) }}
        </h2>
        <span>+</span>
      </div>
      <div
        class="item"
        :active="carasteristicaActivaSecondBanner == 'innovacion'"
        @click="carasteristicaActivaSecondBanner = 'innovacion'"
      >
        <h2 class=" title">
          {{ $t(`vehiculo_electrico['innovacion'].titulo`) }}
        </h2>
        <span>+</span>
      </div>
    </section>
    <section class="carasteristica-descripcion">
      <div class="container">
        <p
          v-html="
            $t(
              `vehiculo_electrico['${carasteristicaActivaSecondBanner}'].descripcion`
            )
          "
        ></p>
      </div>
    </section>
    <section class="dropdown-product-details-container container">
      <dropdown
        v-for="(dropdown, key) in $t(`vehiculo_electrico.dropdowns`)"
        :key="key"
        :title="dropdown.title"
        :contentPanel="dropdown.content"
      ></dropdown>
    </section>
    <section class="opiniones">
      <div class="container">
        <h2 class="title-26">
          {{ $t(`vehiculo_electrico.opiniones_titulo`) }}
        </h2>
        <vue-slick-carousel class="slider-container"  ref="slick3"
            v-bind="slickOptionsVideo">
          <div
            class="slide"
            v-for="(opinion, key) in $t(`vehiculo_electrico['opiniones']`)"
            :data="opinion"
            :key="key"
          >
            <img
              :src="'/static/img/vehiculo-electrico/' + key + '.webp'"
              :alt="opinion.cliente"
              :title="opinion.cliente"
            />
            <p class="title">
              {{ opinion.cliente }}
            </p>
            <p>{{ opinion.descripcion }}</p>
          </div>
        </vue-slick-carousel>
      </div>
    </section>
    <section class="soluciones-aftermarket">
      <div class="container">
        <h2 class="title">
          {{ $t(`vehiculo_electrico.solucionesAftermarkert`) }}
        </h2>
        <h3 class="destacado-amarillo">
          {{ $t(`vehiculo_electrico.subtitulo_soluciones`) }}
        </h3>
        <p v-html="$t(`vehiculo_electrico.descripcion_soluciones`)"></p>
        <router-link class="btn-amarillo" :to="$t('enlaces.contacto')">{{
          $t(`vehiculo_electrico.solicita_info`)
        }}</router-link>
      </div>
      <img
        src="/static/img/img-soluciones.webp"
        :alt="$t('vehiculo_electrico.alt_images.juntas_electricos')"
        :title="$t('vehiculo_electrico.alt_images.juntas_electricos')" width="1663" height="2512" loading="lazy" />
    </section>
  </section>
</template>

<script lang="js">
import Intro from '@/components/view-parts/intros/vehiculo-electrico'
import Video_el from '@/components/parts/video-el-vehiculo-electrico';
import VideoVisualizer from '@/components/parts/video-visualizer.vue';
import Dropdown from '@/components/view-parts/dropdown';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
export default {
  name: 'vehiculo-electrico',
  props: [],
  components: {
    'intro': Intro,
    'video-el': Video_el,
    'video-visualizer': VideoVisualizer,
    'vue-slick-carousel': VueSlickCarousel,
    'dropdown': Dropdown
  },
  mounted() {
    // El intercambio por la version reducida lo hace ahora el atributo `srcset`
    // de cada <img>. Antes se sustituia aqui el `src`, ya renderizada la pagina,
    // cuando el navegador ya habia empezado a descargar la version grande.
  },
  data() {
    return {
      slickOptions: {
        slidesToShow: 3,
        arrows: true,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 800,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              slidesToScroll: 1,

            }
          }
        ]
      },
      slickOptionsVideo: {
        slidesToShow: 2,
        arrows: true,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              adaptiveHeight: false,
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: false,

            }
          }
        ]
      },
      carasteristicaActiva: 'catalogo',
      carasteristicaActivaFull:'porqueElegir',
      carasteristicaActivaSecondBanner:'medioAmbiente',
      video_to_show: '',
      show_video: false,
      isOpen:false

    }
  },
  methods: {
    sendToShow: function (value) {
      this.video_to_show = value;
      this.show_video = true;
    },
    closeVideo: function () {
      this.show_video = false;
      this.video_to_show = '';
    },
     toogleOption: function (id) {
      this.carasteristicaActivaFull = id
      this.isOpen = !this.isOpen;
    }
  }

}
</script>

<style>
.vehiculo-electrico .vh.intro img {
  height: 100%;
  object-fit: cover;
}

.vehiculo-electrico .intro .col-50 {
  background: rgba(5, 66, 121, 0.9);
}

.vehiculo-electrico .intro .col-50-right {
  background: rgba(227, 227, 228, 0.7);
}

.vehiculo-electrico .carasteristicas-vehiculo {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.vehiculo-electrico .carasteristicas-vehiculo .item {
  width: calc(100% / 3);
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  color: white;
  cursor: pointer;
}
.vehiculo-electrico .carasteristicas-vehiculo.-full .item {
  width: 100%;
  background: #82a0bc !important;
}
.vehiculo-electrico .carasteristicas-vehiculo.-four .item {
  width: calc(100% / 4);
}
.vehiculo-electrico .carasteristicas-vehiculo .item img {
  width: auto;
  height: 60px;
}

.vehiculo-electrico .carasteristicas-vehiculo .item .title {
  font-size: 20px;
  max-width: 300px;
  text-align: center;
  margin: 20px 0;
  text-wrap: balance;
}
.vehiculo-electrico .carasteristicas-vehiculo.-four .item .title {
  max-width: 248px;
}
.vehiculo-electrico .carasteristicas-vehiculo.-full .item .title {
  max-width: 100%;
}
.vehiculo-electrico .carasteristicas-vehiculo .item span {
  background-image: url(/static/img/mas-light.svg);
  font-size: 0;
  width: 40px;
  height: 40px;
  background-size: 40px;
  background-position: center center;
  background-repeat: no-repeat;
}

.vehiculo-electrico .carasteristicas-vehiculo .item[active="true"] span {
  background-image: url(/static/img/menos-light.svg);
}

.vehiculo-electrico .carasteristicas-vehiculo .item:first-of-type {
  background: #054279;
}

.vehiculo-electrico .carasteristicas-vehiculo .item:nth-of-type(2) {
  background: #82a0bc;
}

.vehiculo-electrico .carasteristicas-vehiculo .item:last-of-type,
.vehiculo-electrico .carasteristicas-vehiculo.-four .item:nth-of-type(3) {
  background: #02203c;
}
.vehiculo-electrico .carasteristicas-vehiculo.-four .item:last-of-type {
  background: #054279;
}

.carasteristica-descripcion {
  background-color: #dadada;
  padding: 40px 0;
}
.carasteristica-descripcion.-full {
  background-color: white;
  color: #054279;
}
.container-videos-vehiculo {
  padding: 60px 0;
  background-image: url("/static/img/vehiculo-electrico/bg-vehiculos.webp");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.vehiculo-electrico .title-36 {
  text-align: left;
  color: #054279;
  font-weight: 800;
}

.container-videos-vehiculo .title-26 {
  text-align: center;
  margin-bottom: 20px;
}

.container-videos-vehiculo .contenedor {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-around;
  align-items: start;
}

.container-videos-vehiculo .-pink-full {
  margin-top: 60px;
}

.container-videos-vehiculo .contenedor .video-el-vehiculo,
.container-videos-vehiculo .contenedor .contenedorsliderVideos {
  width: 100%;
  padding-top: 54px;
}
.container-videos-vehiculo .contenedor .contenedorsliderVideos,
.container-videos-vehiculo
  .contenedor
  .contenedorsliderVideos
  .video-el-vehiculo {
  padding-top: 0;
}
.container-videos-vehiculo .contenedor .video-el-vehiculo .img-video {
  width: 100%;
  min-height: 285px;
  margin-bottom: 0;
}

.container-videos-vehiculo .contenedor .video-el-vehiculo .contenedor-texto {
  background: white;
  color: #054279;
  position: relative;
  padding: 20px;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* justify-content: space-between; */
  position: relative;
  padding-bottom: 80px;
}
.container-videos-vehiculo
  .contenedor
  .video-el-vehiculo
  .contenedor-texto
  .div-btn {
  position: absolute;
  bottom: 20px;
}

.container-videos-vehiculo
  .contenedor
  .video-el-vehiculo
  .contenedor-texto
  .descargar {
  border: 1px solid #054279;
  padding: 5px 10px;
  margin: 5px 5px 5px 0;
  display: inline-block;
  cursor: pointer;
}
.container-videos-vehiculo
  .contenedor
  .video-el-vehiculo
  .contenedor-texto
  .descargar:last-of-type {
  margin-right: 0px;
}

.container-videos-vehiculo
  .contenedor
  .video-el-vehiculo
  .contenedor-texto
  .abrir {
  background-image: url(/static/img/mas-blue.svg);
  width: 25px;
  height: 25px;
  display: inline-block;
  background-size: 25px;
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
  background-position: center center;
}

.section-experto {
  padding: 60px 0;
  background-color: #f5f5f5;
  position: relative;
  min-height: 65vh;
}

.section-experto img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  max-width: 790px;
  z-index: 1;
}

.section-experto .grid-img-text {
  padding-left: 500px;
}

.section-experto .grid-img-text .destacado-rosa {
  font-weight: 900;
  color: #e6017e;
  display: inline-block;
  font-size: 16px;
}
.section-experto .div-btn {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
}
.section-experto .go {
  font-size: 16px;
  margin-top: 0;
}

.section-experto .grid-img-text .title-26 {
  font-size: 26px;
  line-height: 34px;
  max-width: 57%;
  line-height: 1.6em;
  margin-bottom: 20px;
}

.opiniones {
  padding: 80px 0;
  background: white;
}

.opiniones .title-26 {
  text-align: center;
}

.slider-container .slide img {
  width: 100%;

  height: 200px;
  object-fit: cover;
  object-position: center center;
  margin-bottom: 15px;
}

.slider-container {
  margin: 40px 0;
  position: relative;
}

.slider-container .slide {
  padding: 0 20px;
}

.slider-container .slide p {
  color: #02203c;
}

.slider-container .slide .title {
  color: #02203c;
  font-weight: 700;
  margin-bottom: 5px;
  font-size: 18px;
  text-transform: initial;
}

.slider-container .slick-prev,
.slick-next {
  position: absolute;
  top: calc(100% + 41px) !important;
  z-index: 999;
  display: block;
  margin-top: -30px;
  width: 30px;
  height: 30px;
  color: #fff;
  opacity: 0.8;
  cursor: pointer;
  background-image: url(/static/img/flecha.svg);
  outline: 0;
  font-size: 0;
  border: none;
  background-size: 25px;
  background-repeat: no-repeat;
  background-position: center;
  left: calc(100% - 88px) !important;
  transform: rotate(180deg);
}

.slider-container .slick-next {
  transform: none;
  left: calc(100% - 40px) !important;
  top: calc(100% + 40px) !important;
}
.contenedorsliderVideos .slick-next {
  top: 50% !important;
  right: -35px !important;
  left: initial !important;
  transform: rotate(-360deg);
}
.contenedorsliderVideos .slick-prev {
  top: 47.1% !important;
  right: initial;
  left: -55px !important;
  background-image: url(/static/img/flecha.svg);
  background-size: 25px;
  background-repeat: no-repeat;
  background-position: center;
  transform: rotate(180deg);
}
.soluciones-aftermarket {
  background: #02203c;
  padding: 60px 0;
  position: relative;
  margin-top: 40px;
  min-height: 59vh;
}

.soluciones-aftermarket img {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 400px;
  z-index: 1;
}

.soluciones-aftermarket .container p {
  color: white;
}

.soluciones-aftermarket .container .title {
  color: white;
  font-size: 73px;
  line-height: 0.7em;
  max-width: 400px;
  font-weight: bold;
}

.soluciones-aftermarket .container {
  padding-right: 400px;
}

.soluciones-aftermarket .container .destacado-amarillo {
  background: #ffed03;
  width: max-content;
  padding: 5px 15px;
  color: #02203c;
  margin-top: 5px;
  display: inline-block;
  margin-bottom: 60px;
}
.vehiculo-electrico .container-btns {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.soluciones-aftermarket .container .btn-amarillo,
.vehiculo-electrico .container-btns .btn-amarillo {
  border: 1px solid #ffed03;
  color: #ffed03;
  padding: 5px 30px;
  margin-top: 10px;
  display: inline-block;
  margin-top: 40px;
}
.vehiculo-electrico .container-btns .btn-amarillo {
  margin-bottom: 20px;
  margin-top: 0;
  padding: 5px 20px;
  font-size: 14px;
  min-width: 46%;
  text-align: center;
}
.vehiculo-electrico .intro p {
  margin-bottom: 0;
}
.vehiculo-electrico .video-el-vehiculo {
  margin-top: 20px;
  max-width: 90%;
}
.padding-top-intro {
  padding-top: 53px !important;
}
.btn-blue {
  margin-top: 20px;
  display: flex;
  align-items: center;
}
@media screen and (max-width: 1700px) {
  .section-experto img {
    max-width: 40vw;
  }

  .soluciones-aftermarket img {
    width: auto;
    max-height: calc(100% + 45px);
  }
}

@media screen and (max-width: 1100px) {
  .vehiculo-electrico .carasteristicas-vehiculo .item img {
    height: 40px;
  }

  .vehiculo-electrico .carasteristicas-vehiculo .item span {
    height: 30px;
    height: 30px;
    background-size: 30px;
  }

  .section-experto {
    min-height: auto;
  }

  .section-experto .grid-img-text {
    padding-left: 0;
  }

  .section-experto img {
    max-width: initial;
    position: initial;
    max-height: 400px;
    right: 0;
    margin-top: 20px;
  }

  .section-experto .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: 0 auto;
  }

  .section-experto .grid-img-text .title-26 {
    max-width: 100%;
  }

  .soluciones-aftermarket .container .title {
    font-size: 45px;
  }

  .soluciones-aftermarket .container {
    padding-right: 400px;
  }
  .container-videos-vehiculo .contenedor .video-el-vehiculo .contenedor-texto {
    padding-bottom: 115px;
  }
}
@media screen and (max-width: 900px) {
  .vehiculo-electrico .carasteristicas-vehiculo.-four .item {
    width: calc(100% / 2);
  }
}
@media screen and (max-width: 780px) {
  .vehiculo-electrico .carasteristicas-vehiculo .item {
    width: calc(100% / 2);
    padding: 20px 10px 10px 10px;
    flex-grow: 1;
  }
  .container-videos-vehiculo .contenedor .video-el-vehiculo .img-video {
    background-position: left center !important;
  }
  .container-videos-vehiculo
    .contenedor
    .video-el-vehiculo
    .img-video[datakey="EV000600"],
  .container-videos-vehiculo
    .contenedor
    .video-el-vehiculo
    .img-video[datakey="EV000200"] {
    background-position: right center !important;
  }

  .container-videos-vehiculo .-pink-full {
    margin-top: 20px;
  }
  
  .vehiculo-electrico .carasteristicas-vehiculo .item .title {
    font-size: 15px;
    max-width: 300px;
    text-align: center;
    margin: 10px 0;
    line-height: 1.2em;
  }

  .container-videos-vehiculo .contenedor .video-el-vehiculo,
  .container-videos-vehiculo .contenedor .contenedorsliderVideos {
    width: 100%;
    margin-bottom: 20px;
  }

  .soluciones-aftermarket img {
    width: 100%;
    max-height: initial;
    position: initial;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 30px;
  }

  .soluciones-aftermarket .container {
    padding-right: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  .soluciones-aftermarket .container .destacado-amarillo {
    margin: 0 auto;
    margin-bottom: 20px;
  }

  .soluciones-aftermarket .container .title {
    margin: 0 auto;
  }

  .soluciones-aftermarket .container .btn-amarillo {
    max-width: max-content;
    margin: 0 auto;
    margin-top: 20px;
  }

  .container-videos-vehiculo,
  .section-experto {
    padding: 30px 0;
  }

  .opiniones {
    padding: 30px 0 0 0;
  }

  .section-experto img {
    max-height: 200px;
  }

  .vehiculo-electrico .title-36 {
    text-align: center;
    margin-bottom: 15px;
  }

  .section-experto .grid-img-text .title-26 {
    max-width: 100%;
    line-height: 1.2em;
    font-size: 22px;
  }

  .slider-container .slick-prev,
  .slider-container .slick-next {
    top: calc(100% + -15px) !important;
  }
  .contenedorsliderVideos .slick-prev {
    top: 6.5% !important;
    left: -15px !important;
  }
  .contenedorsliderVideos .slick-next {
    top: 2.6% !important;
    right: -15px !important;
    left: initial !important;
  }
  .vehiculo-electrico .video-el-vehiculo {
    max-width: 100%;
  }
  .slick-list {
    padding: 0 !important;
  }
}

@media screen and (max-height: 790px) {
  .intro .video-el-vehiculo .img-video {
    width: 92%;
    min-height: 244px;
    background-position: top !important;
  }
}
@media screen and (max-width: 650px) {
  .intro .video-el-vehiculo .img-video {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/vehiculo-electrico.vue